import {
    Flex,
    Paragraph,
    pxArrayToRem,
    useStyles,
} from '@archipro-design/aria';

import * as S from './NoResultsSection.style';

interface NoResultsSectionProps {
    resultsType: 'products' | 'professionals' | 'projects' | 'suppliers';
    onClearFilters?: () => void;
}

export const NoResultsSection = (props: NoResultsSectionProps) => {
    const { resultsType, onClearFilters } = props;
    const { css } = useStyles();

    return (
        <Flex column design={{ padding: pxArrayToRem([50, 50, 36, 50]) }}>
            <Paragraph design={{ margin: 0 }} className={css(S.TextStyle)}>
                {`Sorry, 0 ${resultsType} found.`}
            </Paragraph>

            <Paragraph design={{ margin: 0 }} className={css(S.TextStyle)}>
                Try changing the filters
                {onClearFilters && (
                    <>
                        {' or '}
                        <button
                            type="button"
                            onClick={onClearFilters}
                            className="font-inherit cursor-pointer border-none bg-transparent p-0 text-inherit underline hover:no-underline"
                            aria-label="Clear all active filters"
                        >
                            clear all filters
                        </button>
                    </>
                )}
                .
            </Paragraph>
        </Flex>
    );
};
